import { FormHelperText } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { LevelOfCareContext } from '../machines/levelOfCare.machine';
import { useFieldActorSnapshot } from '../hooks/useFieldActorSnapshot';
import { useReservationFormMachines } from '../ReservationFormMachinesContext';

const GurneyAvailabilityMessage = ({ index }: { index: number }) => {
  const { t } = useTranslation('common');

  const { fieldRefs } = useReservationFormMachines();
  const levelOfCareActor = fieldRefs.levelOfCare;
  const levelOfCareSnapshot = useFieldActorSnapshot(levelOfCareActor);
  const { exceedsMeasurementsLimitsByIndex, withinMeasurementsLimitsByIndex } =
    levelOfCareSnapshot.context as LevelOfCareContext;

  const gurneyFilterMessage = exceedsMeasurementsLimitsByIndex[index]
    ? t('reservation.standardGurneyUnavailable')
    : withinMeasurementsLimitsByIndex[index]
      ? t('reservation.bariatricGurneyUnavailable')
      : null;

  if (!gurneyFilterMessage) {
    return null;
  }

  return (
    <FormHelperText sx={{ ml: 2, color: 'text.secondary' }}>
      {gurneyFilterMessage}
    </FormHelperText>
  );
};

export { GurneyAvailabilityMessage };
